import { FC } from "react";

import { ArrowBack } from "@livechat/design-system-icons";
import { Button, Heading, Icon, IconSource, SpacingToken } from "@livechat/design-system-react-components";

import { IViewContainerProps, ViewContainer } from "components/grid";
import Flex from "components/layout/Flex";
import { isInIframe } from "helpers/app";
import { withVar } from "themes/helpers";

interface IProps extends IViewContainerProps {
  onBack(): void;
  backButtonIcon?: IconSource;
}

const FullPageViewContainer: FC<IProps> = ({ children, title, onBack, backButtonIcon, ...props }) => {
  const embeddedInIframe = isInIframe();

  const backButton = (
    <Flex alignItems="center">
      <Flex margin={withVar(SpacingToken.Spacing3)} alignItems="center">
        <Button kind="plain" size="compact" icon={<Icon source={backButtonIcon || ArrowBack} />} onClick={onBack} />
      </Flex>
      <Heading size={embeddedInIframe ? "xs" : "sm"}>{title}</Heading>
    </Flex>
  );

  return (
    <ViewContainer {...props} stackShowBackButton backButton={backButton} placement="main-content">
      {children}
    </ViewContainer>
  );
};

export default FullPageViewContainer;
